module.exports = __webpack_public_path__ + "assets/img/map-marker-2.svg";